import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

//Layout
import MainLayout from "Layouts/Main";

// styles
import "./styles.scss";

//assets
import assets from "../../../../Assets";

// utils
import { validateInput } from "Services/Utils/validateInput";
// import { notifySuccess } from "Services/Utils/toastNotification";

//Custom Components
import InputBox from "Components/InputBox";
import Button from "Components/Button";
import DropDownBox from "Components/Common/DropDownBox";
import ErrorMessage from "Components/ErrorMessage";
import SuccessCard from "Components/Common/SuccessCard";

//redux
import { useDispatch } from "react-redux";
import {
  addProductTraining,
  fetchProductTrainingCategory,
  fetchProductTrainingSubCategory,
} from "../../../../Redux/Slices/contentManagementSlice";
import { uploadSingle } from "../../../../Redux/Slices/mainSlice";

const AddProductTraining = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedSubCategory, setSelectedSubCategory] = useState(null);
  const [selectedLearningType, setSelectedLearningType] = useState(null);
  const [description, setDescription] = useState("");
  const [file, setFile] = useState("");
  const [videoLink, setVideoLink] = useState("");
  const [learningTitle, setLearningTitle] = useState("");
  const [isSuccess, setIsSuccess] = useState(false);
  const [errors, setErrors] = useState([]);

  const [category, setCategory] = useState([]);
  const [subCategory, setSubCategory] = useState([]);
  const [learningType, setLearningType] = useState([
    { value: 1, label: "READING AND WRITING" },
    { value: 2, label: "VISUAL" },
    { value: 3, label: "AUDITORY" },
    { value: 4, label: "KINESTHETIC" },
  ]);

  const handleDropDownChange = (selectedOption) => {
    setSelectedCategory(selectedOption);
    setSelectedSubCategory(null); 
    setSubCategory([]); 
    setErrors({
      ...errors,
      category: "",
      sub_category: "",
    });
    const selectedCategory = category.find(
      (item) => item.category_id === selectedOption.value
    );
    if (selectedCategory) {
      const categoryId = selectedCategory.category_id;
      const getSubCategoryCB = (value) => {
        // console.log(value);
        //add laabel and value for dropdown options
        if (value.data.length !== 0) {
          const updatedSubCategories = value.data.map((item) => ({
            ...item,
            label: item.sub_category_name,
            value: item.sub_category_id,
          }));
          setSubCategory(updatedSubCategories);
        } else {
          setSubCategory([]);
        }
      };
      dispatch(
        fetchProductTrainingSubCategory({
          data: categoryId === 2 ? 5 : categoryId,
          callBack: getSubCategoryCB,
        })
      );
    }
  };
  const handleDropDownChange1 = (selectedOption) => {
    setSelectedSubCategory(selectedOption);
    setErrors({
      ...errors,
      sub_category: "",
    });
  };
  const handleDropDownChange2 = (selectedOption) => {
    setSelectedLearningType(selectedOption);
    setErrors({
      ...errors,
      learningType: "",
    });
  };

  const handleFileChange = (event) => {
    const formData = new FormData();
    formData.append("file", event.target.files[0]);
    const uploadCB = (value) => {
      console.log(value);
      setFile(value.data.url);
      setErrors({
        ...errors,
        file: "",
        videoLink:""
      });
    };
    console.log(event.target.files);

    dispatch(
      uploadSingle({
        data: formData,
        callBack: uploadCB,
      })
    );
  };

  const handleValidation = () => {
    let validationErrors = {};

    const productCategory = validateInput("category", selectedCategory);
    if (productCategory.category) {
      validationErrors.category = productCategory.category;
    }

    // if (selectedCategory?.category_name === "Filtration") {
      const productSubCategory = validateInput("sub_category", selectedSubCategory);
      if (productSubCategory.sub_category) {
        validationErrors.sub_category = productSubCategory.sub_category;
      }
    // }

    const productLearningTitle = validateInput("learningTitle", learningTitle);
    if (productLearningTitle.learningTitle) {
      validationErrors.learningTitle = productLearningTitle.learningTitle;
    }

    const productLearningType = validateInput(
      "learningType",
      selectedLearningType
    );
    if (productLearningType.learningType) {
      validationErrors.learningType = productLearningType.learningType;
    }

    if (!videoLink) {
      const productFile = validateInput("file", file);
      if (productFile.file) {
        validationErrors.file = productFile.file;
      }
    }

    if (!file) {
      const productVideoLink = validateInput("videoLink", videoLink);
      if (productVideoLink.videoLink) {
        validationErrors.videoLink = productVideoLink.videoLink;
      }
    }

    setErrors(validationErrors);
    return validationErrors;
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const validationErrors = handleValidation();
    if (Object.keys(validationErrors).length === 0) {
      // Handle form submission logic here
      const data = {
        product_category_name: selectedCategory?.category_name,
        product_category_id: selectedCategory?.category_id,
        learning_type: selectedLearningType?.value,
        sub_category: selectedSubCategory?.sub_category_name, 
        sub_category_id: selectedSubCategory?.sub_category_id,
        learning_title: learningTitle,
        description: description,
        file_url: file,
        file_type: file.split(".").pop() || "link",
        content_link: videoLink,
      };
      // if (selectedCategory?.category_id !== 4) {
      //   data.sub_category = selectedSubCategory?.sub_category_name || "";
      //   data.sub_category_id = selectedSubCategory?.sub_category_id || "";
      // }
      // console.log(data);
      const addProductCB = (value) => {
        // notifySuccess("Product Training Added Successfully")
        // navigate(-1)
        setIsSuccess(true);
      };
      dispatch(
        addProductTraining({
          data: data,
          callBack: addProductCB,
        })
      );
    }
  };

  useEffect(() => {
    dispatch(
      fetchProductTrainingCategory({
        callBack: getCategoryCB,
      })
    );
  }, []);

  const getCategoryCB = (value) => {
    // console.log(value)
    //add laabel and value for dropdown options
    const updatedCategories = value.data.map((item) => ({
      ...item,
      label: item.category_name,
      value: item.category_id,
    }));
    setCategory(updatedCategories);
  };

  return (
    <MainLayout pageName={"Content Management"}>
      {/* SuccessCard - Conditionally render */}
      {isSuccess && (
        <SuccessCard
          title="Added Successfully"
          subTitle="Product Training Details Added Successfully."
          onClose={() => setIsSuccess(false)} // Close the SuccessCard
          onGoBack={() => navigate(-1)} // Navigate back
          buttonText="Back to Contents"
        />
      )}
      <div className="goBackDiv" onClick={() => navigate(-1)}>
        <img src={assets.Icons.leftArrow} alt="backIcon" />
        <p>Back to Product Training List</p>
      </div>
      <form className="AddProductTrainingContainer" onSubmit={handleSubmit}>
        {/* Header */}
        <div className="AddProductTrainingContainerHeader">
          <h2>Add Product Training Details</h2>
        </div>
        <hr style={{ border: "1px solid #E6E6E6", marginBottom:'45px' }} />
        <div className="AddProductTrainingInputBoxBody">
          <div className="AddProductTrainingInputContainer">
            <p>Product Category</p>
            <div className="AddProductTrainingInputBoxContainer">
              <DropDownBox
                options={category}
                placeholder="Select Category"
                onChange={handleDropDownChange}
                value={selectedCategory}
                customStyles={{
                  control: (provided) => ({
                    ...provided,
                    border: "1px solid #B2BEC3",
                    boxShadow: "none",
                    padding: "5px 3px",
                    fontFamily: "Poppins",
                    fontSize: "2.2vh",
                    marginRight: "10px",
                    height: "7vh",
                  }),
                  menu: (provided) => ({
                    ...provided,
                    color: "#697077",
                  }),
                  option: (provided) => ({
                    ...provided,
                    color: "#697077",
                  }),
                  singleValue: (provided) => ({
                    ...provided,
                    color: "black",
                  }),
                  indicatorSeparator: () => ({ display: "none" }),
                }}
              />
              {errors.category && <ErrorMessage message={errors.category} />}
            </div>
          </div>
          {/* {selectedCategory?.category_name !== "Gearbox/Motors" ?  */}
            <div className="AddProductTrainingInputContainer">
              <p>Stages (Sub Category)</p>
              <div className="AddProductTrainingInputBoxContainer">
                <DropDownBox
                  options={subCategory}
                  placeholder="Select Sub Category"
                  onChange={handleDropDownChange1}
                  value={selectedSubCategory}
                  customStyles={{
                    control: (provided) => ({
                      ...provided,
                      border: "1px solid #B2BEC3",
                      boxShadow: "none",
                      padding: "5px 3px",
                      fontFamily: "Poppins",
                      fontSize: "2.2vh",
                      marginRight: "10px",
                      height: "7vh",
                    }),
                    menu: (provided) => ({
                      ...provided,
                      color: "#697077",
                    }),
                    option: (provided) => ({
                      ...provided,
                      color: "#697077",
                    }),
                    singleValue: (provided) => ({
                      ...provided,
                      color: "black",
                    }),
                    indicatorSeparator: () => ({ display: "none" }),
                  }}
                />
                {errors.sub_category && (
                  <ErrorMessage message={errors.sub_category} />
                )}
              </div>
            </div>
            {/* : ""}  */}
          <div className="AddProductTrainingInputContainer">
            <p>Learning Type</p>
            <div className="AddProductTrainingInputBoxContainer">
              <DropDownBox
                options={learningType}
                placeholder="Select Learning Type"
                onChange={handleDropDownChange2}
                value={selectedLearningType}
                customStyles={{
                  control: (provided) => ({
                    ...provided,
                    border: "1px solid #B2BEC3",
                    boxShadow: "none",
                    padding: "5px 3px",
                    fontFamily: "Poppins",
                    fontSize: "2.2vh",
                    marginRight: "10px",
                    height: "7vh",
                  }),
                  menu: (provided) => ({
                    ...provided,
                    color: "#697077",
                  }),
                  option: (provided) => ({
                    ...provided,
                    color: "#697077",
                  }),
                  singleValue: (provided) => ({
                    ...provided,
                    color: "black",
                  }),
                  indicatorSeparator: () => ({ display: "none" }),
                }}
              />
              {errors.learningType && (
                <ErrorMessage message={errors.learningType} />
              )}
            </div>
          </div>
          <div className="AddProductTrainingInputContainer">
            <p>Learning Title</p>
            <div className="AddProductTrainingInputBoxContainer">
              <InputBox
                inputStyle={{
                  boxShadow: "none",
                  border: "1px solid #B2BEC3",
                  padding: "1px 2vh 1px 2vh",
                  height: "7vh",
                  fontSize: "2.2vh",
                  color: "black"
                }}
                name="learningTitle"
                value={learningTitle}
                onChange={(e) => {
                  setLearningTitle(e.target.value);
                  setErrors({
                    ...errors,
                    learningTitle: "",
                  });
                }}
              />
              {errors.learningTitle && (
                <ErrorMessage message={errors.learningTitle} />
              )}
            </div>
          </div>
        </div>
        <div className="AddProductTrainingTextContainer">
          <p>Description</p>
          <div className="AddProductTrainingInputBoxContainer">
            <textarea
              value={description}
              onChange={(e) => {
                setDescription(e.target.value);
                setErrors({
                  ...errors,
                  description: "",
                });
              }}
              rows="5"
              placeholder="Enter description here"
              className="textAreaInput"
            />
            {errors.description && (
              <ErrorMessage message={errors.description} />
            )}
          </div>
        </div>

        <div className="AddProductTrainingTextContainer">
          <p style={{ marginBottom: "20px" }}>Upload File</p>
          <div className="fileUploadContainer">
            <label htmlFor="uploadFile" className="uploadFileLabel">
              Upload
              <input
                type="file"
                id="uploadFile"
                accept=".pdf,.mp4,.mov,.mpeg,.webm,.mkv"
                style={{ display: "none" }}
                onChange={handleFileChange}
              />
            </label>
            {errors.file && (
              <div style={{ marginTop: "1rem" }}>
                {" "}
                <ErrorMessage message={errors.file} />{" "}
              </div>
            )}
          </div>
        </div>
        {file !== "" ? (
          <p style={{ marginTop: "1rem" }}>{file.split("---").pop()}
          {file ? (
                    <span
                      style={{
                        color: "red",
                        marginLeft: "10px",
                        fontSize: "16px",
                        cursor: "pointer",
                      }}
                      onClick={() => setFile("")}
                    >
                      X
                    </span>
                  ) : (
                    ""
                  )}</p>
        ) : (
          ""
        )}

        <p style={{ marginTop: "20px", color: "#7A7A7A", fontSize: "2vh" }}>
          OR
        </p>

        <div className="AddProductTrainingTextContainer">
          <p>Video Link</p>
          <div className="AddProductTrainingInputBoxContainer">
            <InputBox
              inputStyle={{
                border: "1px solid #B2BEC3",
                padding: "1px 2vh 1px 2vh",
                height: "7vh",
                boxShadow: "none",
                fontSize: "2.2vh",
                color: "black"
              }}
              name="videoLink"
              value={videoLink}
              onChange={(e) => {
                setVideoLink(e.target.value);
                setErrors({
                  ...errors,
                  videoLink: "",
                  file: "",
                });
              }}
            />
            {errors.videoLink && <ErrorMessage message={errors.videoLink} />}
          </div>
        </div>

        <div className="addStaffButtons">
          <div className="addStaffButtonContainer">
            <Button
              buttonStyle={{ height: "2vh", backgroundColor: "#FFFFFF" }}
              titleStlye={{ color: "#888888" }}
              title="Cancel"
              onClick={() => navigate(-1)}
            />
          </div>
          <div className="addStaffButtonContainer">
            <Button
              forForm={true}
              buttonStyle={{ height: "2vh" }}
              title="Add"
            />
          </div>
        </div>
      </form>
    </MainLayout>
  );
};

export default AddProductTraining;
